'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Subtitle = undefined;

var _themeProvider = require('@spp/theme-provider');

var _Subtitle = require('./Subtitle');

var _Subtitle2 = _interopRequireDefault(_Subtitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.Subtitle = _Subtitle2.default;
exports.default = (0, _themeProvider.themer)('@spp/ui-subtitle')(_Subtitle2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-subtitle/lib/cjs/index.js
 ** module id = 275
 ** module chunks = 1
 **/